import React from "react"
import { withTheme } from "emotion-theming"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import { Container, GoldenRatio } from "@components/grid"
import { Heading } from "@components/type"

import Main from "./main"
import Side from "./side"

import { Wrapper } from "./styles"

const sectionTitle = "Education Department"

const Education = ({ theme }) => (
  <Wrapper>
    <Container maxWidth="1200px">
      <Heading colour={theme.colours.primary}>{sectionTitle}</Heading>
      <GoldenRatio main={<Main />} side={<Side />} />
      <ViewButton to="/education" colour={theme.colours.primary}>
        View
        <VisuallyHidden> {sectionTitle}</VisuallyHidden>
      </ViewButton>
    </Container>
  </Wrapper>
)

export default withTheme(Education)
